module.exports = __webpack_public_path__ + "static/gnoll_flesh_gnawer-00b87c03205ca84eed0d7c816fd3c536.jpeg";